import { render, staticRenderFns } from "./SpecificBodyPartsList.vue?vue&type=template&id=f67dc6d6"
import script from "./SpecificBodyPartsList.vue?vue&type=script&lang=js"
export * from "./SpecificBodyPartsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports